import React from 'react';

import MessageInfo from '../../../components/messageInfo/MessageInfo';
import { EmployeeDimHisDetail } from '../employeeDimensionHistory/employee-dimension-history-service';

type EmployeeDimHisDetailsProps = {
    employeeDimHisDetail: EmployeeDimHisDetail;
};

export const EmployeeDimHisDetails = ({ employeeDimHisDetail }: EmployeeDimHisDetailsProps) => {
    if (employeeDimHisDetail) {
        return (
            <div className="card mt-3 border-0">
                <div className="card-header border-0" style={{ backgroundColor: '#ebf2f9', padding: '15px' }}>
                    Details
                </div>
                <div className="card-body tableContentCardBody">
                    <div className="row">
                        {[
                            {
                                label: 'Parent Client',
                                value: employeeDimHisDetail?.parent_client ?? '--',
                                border: true,
                            },
                            {
                                label: 'Client',
                                value: employeeDimHisDetail?.client ?? '--',
                                border: true,
                            },
                            {
                                label: 'Program',
                                value: employeeDimHisDetail?.program ?? '--',
                                border: true,
                            },
                            {
                                label: 'Team Lead',
                                value: employeeDimHisDetail?.team_lead ?? '--',
                                border: true,
                            },
                            {
                                label: 'Manager',
                                value: employeeDimHisDetail?.manager ?? '--',
                                border: true,
                            },
                            {
                                label: 'Site',
                                value: employeeDimHisDetail?.site ?? '--',
                            },
                        ].map((item) => (
                            <div
                                className={item.border === true ? 'col-md-2 border-end' : 'col-md-2'}
                                // style={{ width: '14.2%' }}
                                key={item.label}
                            >
                                <div className="row">
                                    <div className="col-md-12 mt-1">
                                        <strong>{item.label}</strong>
                                    </div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col-md-12" style={{ fontWeight: '400' }}>
                                        {item.value}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="col-12">
            <MessageInfo title="" message="No Employee Dimension History found." rowHeight="50px" />
        </div>
    );
};
